import Choices from "choices.js";
import Swiper from "swiper";

export default class ReviewSlider {

    constructor() {
        this.initReviews();
    }

    initReviews() {
        if(document.querySelectorAll('#reviewSlider') !== null){
            new Swiper('#reviewSlider .swiper-container', {
                slidesPerView: 1,
                spaceBetween: 30,
                loop:true,
                autoplay: {
                    delay: 4500,
                },
                breakpoints: {
                    576: {
                        slidesPerView: 1,
                    },
                    1200: {
                        slidesPerView: 1,
                    }
                },
                navigation: {
                    nextEl: "#beoordelingen .swiper-button-next",
                    prevEl: "#beoordelingen .swiper-button-prev",
                },
            });
        }
    }
}
